import { MousePointer2 } from "lucide-react";
import { motion } from "motion/react";

interface Cursor {
  name: string;
  color: string;
  path: { x: string; y: string }[];
}

const cursors: Cursor[] = [
  {
    name: "Sarah",
    color: "#3B82F6", // blue
    path: [
      { x: "25%", y: "20%" },
      { x: "35%", y: "25%" },
      { x: "40%", y: "35%" },
      { x: "30%", y: "40%" },
      { x: "25%", y: "20%" },
    ],
  },
  {
    name: "Karolis",
    color: "#8B5CF6", // purple
    path: [
      { x: "65%", y: "15%" },
      { x: "70%", y: "25%" },
      { x: "75%", y: "20%" },
      { x: "70%", y: "30%" },
      { x: "65%", y: "15%" },
    ],
  },
  {
    name: "Rasmus",
    color: "#EC4899", // pink
    path: [
      { x: "50%", y: "60%" },
      { x: "60%", y: "65%" },
      { x: "55%", y: "70%" },
      { x: "45%", y: "65%" },
      { x: "50%", y: "60%" },
    ],
  },
];

function AnimatedCursor({ cursor, delay }: { cursor: Cursor; delay: number }) {
  return (
    <motion.div
      className="pointer-events-none absolute z-30"
      initial={{ left: cursor.path[0].x, top: cursor.path[0].y }}
      animate={{
        left: cursor.path.map((p) => p.x),
        top: cursor.path.map((p) => p.y),
      }}
      transition={{
        duration: 12,
        repeat: Infinity,
        ease: "linear",
        delay: delay,
      }}
    >
      <div className="relative">
        {/* Cursor icon */}
        <MousePointer2
          className="h-5 w-5 drop-shadow-lg"
          style={{ color: cursor.color, fill: cursor.color }}
        />

        {/* Name label */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3, delay: delay + 0.5 }}
          className="absolute top-0 left-6 rounded px-2 py-1 text-xs whitespace-nowrap text-white shadow-lg"
          style={{ backgroundColor: cursor.color }}
        >
          {cursor.name}
        </motion.div>

        {/* Subtle glow effect */}
        <div
          className="absolute -inset-2 rounded-full opacity-40 blur-md"
          style={{ backgroundColor: cursor.color }}
        />
      </div>
    </motion.div>
  );
}

export default function CollaborativeCursors() {
  return (
    <>
      {cursors.map((cursor, index) => (
        <AnimatedCursor key={cursor.name} cursor={cursor} delay={index * 2} />
      ))}
    </>
  );
}
